var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"body flex-column"},[_c('AppToolbar'),(_vm.allowedAccess)?_c('v-sheet',{staticClass:"flex-grow-1 overflow-container",attrs:{"color":"blue-grey lighten-5"}},[_c('router-view')],1):_c('ForbiddenView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }